import type { PlanMigrationSchema } from '../types/plan-migration';

interface RootState {
    planMigration?: PlanMigrationSchema;
}

export const getPlanMigrationIsOpen = (state: RootState) =>
    state.planMigration?.isOpen ?? false;

export const getPlanMigrationIsChecked = (state: RootState) =>
    state.planMigration?.isChecked ?? false;

export const getPlanMigrationData = (state: RootState) =>
    state.planMigration?.migrationData ?? null;
